import { getWcBrand } from '../../../src/worldcup/helpers/wcBrand.helper';

export const GROUP_INFO_SHEET_COPY = {
  MEMBERS_SECTION: 'MEMBERS',
  PRIZE_POOL_SECTION: 'PRIZE POOL',
  ABOUT_SECTION: 'ABOUT',
  INVITE_SECTION: 'INVITE CODE',
  PRIZES_SECTION: 'PRIZES',
  COPY_CODE: 'Copy',
  SHARE_CODE: 'Share',
  MEMBER_LABEL_COMPANY: 'members',
  MEMBER_LABEL_COMMUNITY: 'members',
  LEAVE_SQUAD: 'Leave squad',
  LEAVE_SQUAD_NOTE: 'Your picks and points stay with the squad history.',
  SOLE_ADMIN_LEAVE_NOTE:
    'You are the only squad admin. Another member must be promoted to admin before you can leave (contact support if needed).',
  PLACE_LABELS: { 1: '1st Place', 2: '2nd Place', 3: '3rd Place' } as Record<number, string>,
  SAVE_SQUAD_NAME: 'Save',
  CANCEL_RENAME: 'Cancel',
  EDIT_SQUAD_NAME_A11Y: 'Edit squad name',
} as const;

export const getShareInviteTitle = (): string => `${getWcBrand().NAME} squad invite`;

export const PRIZE_MEDALS: Record<number, string> = { 1: '🥇', 2: '🥈', 3: '🥉' };

export function buildShareInviteMessage(groupName: string, inviteLink: string): string {
  return `Join my ${getWcBrand().NAME} squad "${groupName}" on Zporti! ${inviteLink}`;
}

export const GROUP_INFO_SHEET_MEMBERS_MAX = 5;
export const GROUP_INFO_SHEET_AVATAR_SIZE = 44;
export const GROUP_INFO_SHEET_SLIDE_DISTANCE = 420;
